<script>
/**
 * Descripción: Pantalla para Gestionar Partner
 *
 * @displayName PartnerEditorViewComponent
 */

import { mapActions } from 'vuex';
import httpService from '@/services/httpService.js';
import BaseArrayHelper from '@/helpers/BaseArrayHelper.js';

const PartnerContactFilterViewComponent = () =>
  import('@/views/Partner/PartnerContactFilterViewComponent.vue');

const PartnerByCustomerFilterViewComponent = () =>
  import('@/views/PartnerByCustomer/PartnerByCustomerFilterViewComponent.vue');

export default {
  name: 'PartnerEditorViewComponent',

  components: {
    PartnerContactFilterViewComponent,
    PartnerByCustomerFilterViewComponent
  },

  data() {
    return {
      partner: this.$_setPartnerObject(),
      loading: false,
      textFieldProps: {
        'append-icon': 'mdi-calendar'
      },
      extraParams: {
        customerId: '',
        partnerId: this.$router.currentRoute.params.Id
      },
      customerId: undefined
    };
  },

  created() {
    /**
     * Configuracion Encabezado
     */
    this.addNavbar(['Gestionar Partner']);

    /**
     * Determinar si Es nuevo / editor
     */
    this.$_getObject();
  },

  methods: {
    /**
     * Determinar si Es nuevo / editor
     */
    $_getObject() {
      let data = this.$router.currentRoute.params.Id;
      if (data) {
        //HttpServices a la vista para obtener Vista
        this.partner.partnerId = data;
        this.loading = true;
        httpService.post('/Partner/GetView', this.partner).then(response => {
          this.loading = false;
          if (response != undefined) {
            // Encontro la entidad
            this.partner = BaseArrayHelper.SetObject({}, response.data);

            this.partner.activationDate = new Date(
              this.partner.activationDate.replace(/T/g, ' ')
            );
          } else {
            this.$_returnToFilter();
          }
        });
      }
    },

    /**
     * Configuración NavBar
     */
    ...mapActions('navbar', ['addNavbar']),

    /**
     * Obj de la pantalla
     */
    $_setPartnerObject() {
      return {
        partnerId: undefined,
        partnerName: undefined,
        locationId: undefined,
        activationDate: undefined,
        inactivationDate: undefined,
        activo: true
      };
    },

    /**
     * Volver al Filtro
     */
    $_returnToFilter() {
      this.$router.push({ name: 'PartnerFilterViewComponent' });
    },

    $_sendToApi() {
      this.loading = true;
      let object = BaseArrayHelper.SetObject({}, this.partner);
      httpService.post('Partner/Save', object).then(response => {
        if (response != undefined) {
          //Logica JS luego de la acción exitosa!!!
          this.$router.push({ name: 'PartnerFilterViewComponent' });
        }
        this.loading = false;
      });
    },

    $_sendToApiPartner() {
      httpService
        .post('PartnerByCustomer/SaveObject', {
          customerId: this.customerId,
          partnerId: parseInt(this.$router.currentRoute.params.Id)
        })
        .then(response => {
          if (response != undefined) {
            //Logica JS luego de la acción exitosa!!!
            this.$refs.PartnerByCustomer.$_refresh();
            this.$_openModal();
            this.customerId = undefined;
          }
        });
    },

    /**
     * Open PopUp
     */
    $_openModal() {
      this.$refs.modalPopUp.$_openModal();
    }
  }
};
</script>

<template>
  <div>
    <!-- @ Use Loanding... -->
    <BaseSkeletonLoader v-if="loading" type="card-avatar, article, actions" />
    <div v-else>
      <!-- @BaseDialog -->
      <BaseDialog ref="modalPopUp" tittle="Customers">
        <div slot="Content">
          <BaseForm :method="$_sendToApiPartner" :cancel="$_openModal">
            <div slot="body">
              <!-- @BaseSelect -->
              <BaseSelect
                v-model="customerId"
                label="Cliente"
                endpoint="/Customer/GridWithList"
                itemText="customerName"
                itemValue="customerId"
              />
            </div>
          </BaseForm>
        </div>
      </BaseDialog>
      <h3>Gestionar Partner</h3>
      <v-divider></v-divider>
      <v-flex xs12 sm12 md12>
        <!-- @BaseForm -->
        <!-- @BaseForm -->
        <BaseForm :method="$_sendToApi" :cancel="$_returnToFilter">
          <div slot="body">
            <v-row>
              <v-col cols="12" md="6">
                <!-- @BaseInputList -->
                <BaseInput
                  label="Nombre"
                  v-model="partner.partnerName"
                  :validate="['text']"
                  :max="100"
                />
              </v-col>
              <v-col cols="12" md="6">
                <!-- @BaseSelect -->
                <BaseSelect
                  v-model="partner.locationId"
                  label="Locación"
                  endpoint="/Location/GridWithList"
                  itemText="locationName"
                  itemValue="locationId"
                  :validate="['text']"
                />
              </v-col>
              <v-col cols="12" md="6">
                <!-- @BaseDatePicker -->
                <BaseDatePicker
                  label="Fecha de Activación"
                  type="date"
                  v-model="partner.activationDate"
                  :textFieldProps="textFieldProps"
                  :validate="['text']"
                />
              </v-col>
              <v-col cols="12" md="6" v-if="partner.inactivationDate">
                <!-- @BaseInputList -->
                <BaseInput
                  label="Fecha de Inactivación"
                  v-model="partner.inactivationDate"
                  :max="100"
                  :readonly="true"
                />
              </v-col>
              <v-col cols="12" md="6">
                <div
                  class="pa-2"
                  style=" display: flex;
                        align-items: center;
                        justify-content: center;"
                >
                  <BaseSwitch v-model="partner.activo" label="Estado" />
                </div>
              </v-col>
            </v-row>
          </div>
          <!-- @slot Use this slot afterForm -->
          <div slot="afterForm" v-if="this.$router.currentRoute.params.Id">
            <h3>Contactos</h3>
            <v-divider></v-divider>
            <br />
            <PartnerContactFilterViewComponent :extraParams="extraParams" />

            <h3>Clientes</h3>
            <v-divider></v-divider>
            <br />
            <PartnerByCustomerFilterViewComponent
              ref="PartnerByCustomer"
              :extraParams="extraParams"
              :fnNew="$_openModal"
            />
          </div>
        </BaseForm>
      </v-flex>
    </div>
  </div>
</template>
